module.exports = __webpack_public_path__ + "static/media/hogge-engineering-logo-hc.a6188b25.svg";